module.exports = __webpack_public_path__ + "img/borderLeftLongWhite.76454bfc.svg";